// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Faq',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [12, 25, 50, 68, 85],
      pageIdList: [28, 97, 108, 109 ,110],
      // data
      swiperSlides: '',
      pageInfo: '',
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getAdPictureList();
      this.getPageInfo();
    },
    // 根据id获取页面内容
    getPageInfo() {
      const param = {
        id: this.pageIdList[this.LangIndex],
      };
      ModelService.getPageInfo(param).then((res) => {
        if (res.code === 0) {
          this.pageInfo = res.data;
        }
      });
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data[0];
        }
      });
    },    
  },
};
